<template>
  <div class="content">
    <div class="box">
      <img src="@/assets/images/system/download.png" alt="" srcset="" class="bg" />
      <a href="javascript:void(0);" class="btn hide-btn"></a>
      <button class="btn show-btn" id="openAppBtn" @click="openOverlay"></button>
      <!-- <a href="https://res.cloudcity.chinacici.cn/apk/app-envPro-release.apk" class="btn"></a> -->
      <van-overlay :show="showOverlay">
        <div class="wrapper">
          <img src="@/assets/images/system/float.png" alt="" />
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
const SFApi = window.SFApi
const isInClient = SFApi.isInClient()
import { strToHexCharCode } from '@/utils/convertUtil.js'
export default {
  data() {
    return {
      showOverlay: false,
      isInClient: isInClient
    }
  },
  mounted() {
    this.initOpenNativeOrDownload()
  },
  methods: {
    initOpenNativeOrDownload() {
      if (isInClient) {
        return false
      }
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://web.cdn.openinstall.io/openinstall.js'
      document.getElementsByTagName('head')[0].appendChild(script)
      // const that = this
      script.onload = function () {
        var data = window.OpenInstall.parseUrlParams() //openinstall.js中提供的工具函数，解析url中的所有查询参数
        var url = strToHexCharCode(location.href)
        console.log(url)
        new window.OpenInstall(
          {
            /*appKey必选参数，平台为每个应用分配的ID*/
            appKey: 'q3c0mj',
            /*直接指定渠道编号，默认通过当前页url中的channelCode参数自动检测渠道编号*/
            channelCode: 'IGaoXin',
            /*自定义遮罩的html*/
            //mask:function(){
            //  return "<div id='_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
            //},
            /*初始化完成的回调函数，可选*/
            onready: function () {
              /*在app已安装的情况尝试拉起app*/
              this.schemeWakeup() //延迟指定绑定参数与渠道编号
              // this.schemeWakeup()
              /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
              var m = this
              var button = document.getElementById('openAppBtn')
              button.onclick = function () {
                // m.schemeWakeup({ data: { link: url } })
                m.wakeupOrInstall() //延迟指定绑定参数与渠道编号
                // m.wakeupOrInstall()
                /*跳过scheme拉起，直接安装*/
                //m.install({data:data,channelCode:"test-channelcode"});//延迟指定绑定参数与渠道编号
                return false
              }
            }
          },
          data
        )
      }
    },
    clickOpenAppBtn() {
      const btn = document.getElementById('openAppBtn')
      btn.click()
    },
    openOverlay() {
      const that = this
      if (that.isAndroid()) {
        // 安卓
        if (that.isWeiXin()) {
          that.showOverlay = true
        }
      } else {
        // 苹果
        location.href = 'https://apps.apple.com/cn/app/id1664635131'
      }
    },
    isAndroid() {
      const ua = window.navigator.userAgent
      if (ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1) {
        return true
      }
      return false
    },
    isWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="stylus" scoped>
.content
  height: 100%
  overflow-y: auto
  padding: 0
  .box
    position: relative
.bg
  display: block
  width: 100%
.btn
  display: block
  width: 440px
  height: 100px
  position: absolute
  top: 1610px
  left: 50%
  margin-left: -220px
.show-btn
  background-color transparent
  border 0
.hide-btn
  top: 1730px
  background: #338dff
</style>
